export const LOAD_EXCHANGES_INFO = 'LOAD_EXCHANGES_INFO';
export const EDIT_EXCHANGE_HANDLERS_ACCOUNTS = 'EDIT_EXCHANGE_HANDLERS_ACCOUNTS';
export const ADD_EXCHANGE_AGGREGATOR_USER = 'ADD_EXCHANGE_AGGREGATOR_USER';
export const DELETE_EXCHANGE_AGGREGATOR_USER = 'DELETE_EXCHANGE_AGGREGATOR_USER';
export const RESET_EXCHANGES = 'RESET_EXCHANGES';
